import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './PhotoGrid.css';

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

const itemVariants = {
  hidden: { opacity: 0, clipPath: 'inset(0 0 100% 0)' },
  visible: {
    opacity: 1,
    clipPath: 'inset(0 0 0% 0)',
    transition: { duration: 1.2, ease: [0.77, 0, 0.175, 1] },
  },
};

function PhotoItem({ photo, index, onClick }) {
  return (
    <motion.button
      type="button"
      aria-label={`Open photo: ${photo.alt}`}
      className="photo-item"
      variants={itemVariants}
      onClick={() => onClick(index)}
    >
      <motion.img
        src={photo.src}
        alt={photo.alt}
        loading="lazy"
        initial={{ scale: 1.15 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: [0.77, 0, 0.175, 1] }}
      />
    </motion.button>
  );
}

function PhotoGrid({ photos, onPhotoClick }) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <motion.div
      className="photo-grid"
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
    >
      {photos.map((photo, index) => (
        <PhotoItem
          key={photo.src}
          photo={photo}
          index={index}
          onClick={onPhotoClick}
        />
      ))}
    </motion.div>
  );
}

export default PhotoGrid;
